export enum CouplingStatus {
  Coupled = 0,
  PendingApproval = 1,
  BlockedNoEmail = 2,
}

export enum ApprovalStatus {
  Approved = 0,
  Rejected = 1,
  Expired = 2,
  AlreadyProcessed = 3,
  Invalid = 4,
}

export interface CouplingResultDto {
  status: CouplingStatus;
}

export interface ApprovalResultDto {
  status: ApprovalStatus;
  // E-mailadres van de aanvragende mijnAssist-gebruiker (enkel bij Approved/Rejected).
  requesterEmail?: string;
}
